const ELLIPSIS = '...';

export function truncate(input: string, threshold: number): string {
  if (input.length < threshold) {
    return input;
  }

  return `${input.substring(0, threshold - ELLIPSIS.length)}${ELLIPSIS}`;
}
